import styled from "styled-components";

export const LiveCasinoGridItemSkeletonTitleBox = styled.div`
  padding: 0.5em 1em;
  font-size: 1.2em;
  color: rgba(0, 0, 0, 0);;
  overflow: hidden;

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    padding: 0.25em 0.5em;
  }
  animation: AmountSkeletonAnimation 1.5s linear infinite;
    @keyframes AmountSkeletonAnimation {
        0% {
            background-color: ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
        }
        50% {
            background-color: ${props => props.theme.colors.bodyBackgroundLight};
        }
        100% {
            background-color: ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
        }
    }
`;